import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseWrapper = ({
  buttons,
  children,
  isStarted
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "practical-exercise-wrapper",
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "100%",
        flexDirection: "row",
        justifyContent: "start",
        paddingInlineEnd: "250",
        children: [!isMobile && /*#__PURE__*/_jsx(View, {
          paddingInline: "1000",
          children: /*#__PURE__*/_jsx(Pictogram, {
            name: isStarted ? 'Workflow' : 'Notes'
          })
        }), /*#__PURE__*/_jsx("div", {
          children: children
        })]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: buttons
    })]
  });
};
export default PracticalExerciseWrapper;